<template>
  <div class="select-user-box">
    <el-dialog width="50%" :title="title" :visible.sync="show" :close-on-click-modal='false' :append-to-body='isAppend' :class="{'select-user-dialog':isAppend}" @close='close'>
      <span slot="title" class="dialog-footer">
        <span>{{title}}</span>
      </span>
      <el-form :model="user" class="demo-form-inline" label-position="top" ref="form">
         <el-tag v-for="(tag,index) in tags" :key='index' size="small" type='danger' effect="dark" closable :disable-transitions="false" @close="removeTag(tag)">
              {{tag.memberName}}
            </el-tag>
        <el-form-item prop="name" :label="field" :rules="[{ required: false, message: '请选择'+field, trigger: 'change' }]">
          <el-autocomplete  v-model="user.name" value-key='name' :fetch-suggestions="querySearchAsync" :placeholder="'请输入'+field" @select="handleSelect"></el-autocomplete>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close" size="medium">取 消</el-button>
        <el-button type="primary" @click="callBack" size="medium">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as userApi from '../../api/userAPI'
import * as resourceApi from '../../api/resourceAPI'

export default {
  components: {

  },
  props: {
    'is-append': {
      type: Boolean,
      default: true
    },
    'show': {
      type: Boolean,
      default: true
    },
    'title': {
      type: String,
      default: ""
    },
    'field': {
      type: String,
      default: "处理人"
    },
   /*  'tags': {
      type: Array,
      default: function () {
        return []
      }
    }, */
  },
  data() {
    return {
      userList: [],
      user: {},
      tags:[]
    };
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  async mounted() {
   await this.qryList()
  },
  methods: {
    async qryList() {
      let userInfo = await this.$store.getters.getUserInfo
      let res
      let param = {}
      let ids = this.tags.map(t => t.memberId)
      if (this.field == '处理人') {
        res = await userApi.findAll()
        if (res.flag) {
          // this.userList = res.data.filter(u => u.id != userInfo.id)
          this.userList = res.data
        }
      } else if (this.field == '转办人') {
          res = await userApi.findAll()
        if (res.flag) {
          this.userList = res.data.filter(u => u.id != userInfo.id)
        }
      } else if (this.field == '专家') {
        param.name = 'tb_master'
        res = await resourceApi.list(param)
        if (res.flag) {
          this.userList = res.data.list.filter(u => !ids.includes(u.id))
        }
      } else if (this.field == '学员') {
        param.name = 'tb_student'
        res = await resourceApi.list(param)
        if (res.flag) {
          this.userList = res.data.list.filter(u => !ids.includes(u.id))
        }
      }
    },
    callBack() {
      console.log("callBack", this.user);
      if (['处理人','转办人'].includes(this.field)) {
        if(!this.user.id){
          this.$message.error("请选择一个" + this.field)
          return
        }
      }else{
        if(!this.tags.length){
          this.$message.error("请选择一个" + this.field)
          return
        }
      }
      if(['处理人','转办人'].includes(this.field)){
        this.$emit('getResult', this.user)
      }else{
        this.$emit('getResult', this.tags)
      }

    },
    handleSelect(item) {
      console.log("handleSelect", item);
      this.$set(this.user,'id',item.id)
      this.$set(this.user,'name',item.name)
      this.$forceUpdate()
      if( !['处理人','转办人'].includes(this.field)){
        if(!this.tags.find(t =>t.memberId == item.id)){
          this.tags.push({ memberId: item.id, memberName: item.name ,projectId:this.$route.params.id,memberType:this.field == '专家'?'1':'0'})
        }
        this.$set(this.user,'id','')
        this.$set(this.user,'name','')
        this.userList = this.userList.filter(u => u.id != item.id)
      }
      //this.user.id = item.id
    },

    querySearchAsync(queryString, cb) {
      console.log("queryString", queryString, this.userList)
      let results = queryString ? this.userList.filter(item => item.name.includes(queryString.replace(/^\s+|\s+$/gm, ''))) : this.userList;
      console.log("results", queryString, results);
      // this.user.id = 0
      results = results.slice(0, 10)
      cb(results);

    },

    close() {

      this.$emit('close')
      this.$refs.form.resetFields()
      this.tags = []
    },
    removeTag(tag){
      this.tags = this.tags.filter(t => t.memberId != tag.memberId)
    },
    setTags(tags){
      console.log('setTags',tags);
      this.tags = tags
    }
  },
};
</script>

<style  lang="less">
.select-user-dialog {
  .el-dialog {
    padding-left: 20px;
    max-width: 720px;
    .el-dialog__body {
      padding-right: 40px;
      .el-autocomplete {
        width: 100%;
        margin-right: 40px;
      }
    }
    .el-dialog__footer {
      padding-right: 40px;
    }
  }
  .el-tag{
    margin-left: 10px;
    margin-bottom: 10px;
  }
}
</style>
